import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import { LatLngExpression } from 'leaflet';
import { Circle, LayerGroup, Marker, Polygon, useMap } from 'react-leaflet';

import { sections } from './geoSections';

import { getCentroid } from '../Helpers/getCentroid';
import { getSelectedSection } from '../Helpers/getSelectedSection';
import useMyLocation from '../Hooks/useMyLocation';

import StaticMarker from '../../MapControls/StaticMarker';

const polygonConfig = { fillColor: 'black', weight: 1, color: 'black',  opacity: 0, fillOpacity: 0  };

type TPositions = LatLngExpression[] | LatLngExpression[][] | LatLngExpression[][][];

type TProps = {
    draggableMarkerPosition?: { lat: number, lng: number };
    getLatLng?: (val: { lat: number; lng: number }) => void;
    getSection?: (val: string | null) => void;
};

const UniversitySections = ({ draggableMarkerPosition, getLatLng, getSection }: TProps) => {
    const map = useMap();
    const [zoom, setZoom] = useState(map.getZoom());
    const myPosition = useMyLocation(getLatLng, getSection); // Listens to onclick event on buttons with id "btn-my-location"

    // Get current map zoom
    useEffect(() => {
        map.on("zoomend", function () {
            setZoom(map.getZoom());
        });
    }, [map]);

    // Trigger getLatLng and getSection callback functions
    const handleGetMapAttributes = (val: { lat: number; lng: number }) => {
        getLatLng && getLatLng(val);
        getSection && getSection(getSelectedSection([val.lat, val.lng]));
    };

    return (
        <>
            <StaticMarker getLatLng={handleGetMapAttributes} draggableMarkerPosition={myPosition ? myPosition : draggableMarkerPosition} />
            {sections.map((section, id) => {
                // const center = getCentroid(section.arr) as LatLngExpression;
                // const text = L.divIcon({ html: section.name, className: 'section-map-circle-icon' }); // css defined at GlobalStyles.tsx

                return (
                    <React.Fragment key={id}>
                        <Polygon key={id} pathOptions={polygonConfig} positions={section.arr as TPositions} />
                        {/* <>
                            <LayerGroup>
                                {zoom >= 16 && (
                                    <Circle center={center} fillColor="white" color="white" fillOpacity={1} radius={10}>
                                        <Marker position={center} icon={text} />
                                    </Circle>
                                )}
                            </LayerGroup>
                        </> */}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default UniversitySections;
